/*
 * -----------------------------------------------------------------------
 *  <copyright file="study-visit-schedules.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';
import { StudyVisitScheduleFragment, StudySubjectVisitFragment, StudyVisitScheduleRuleFieldFragment } from './fragments';

export const GET_STUDY_VISIT_SCHEDULES = gql`
    query studyVisitSchedules($studyId: ObjectId!, $timestamp: DateTime) {
        studyVisitSchedules(studyId: $studyId, timestamp: $timestamp) {
            ...StudyVisitScheduleFields
        }
    }
    ${StudyVisitScheduleFragment}
`;

export const SAVE_STUDY_VISIT_SCHEDULE = gql`
    mutation saveStudyVisitSchedule($studyId: ObjectId!, $visitSchedule: StudySubjectVisitScheduleTemplateInput!, $reason: String) {
        saveStudyVisitSchedule(studyId: $studyId, visitSchedule: $visitSchedule, reason: $reason) {
            ...StudyVisitScheduleFields
        }
    }
    ${StudyVisitScheduleFragment}
`;

export const SAVE_STUDY_VISIT_SCHEDULE_VERSION = gql`
    mutation saveStudyVisitScheduleVersion($studyId: ObjectId!, $visitScheduleVersion: StudySubjectVisitScheduleTemplateInput!, $reason: String) {
        saveStudyVisitScheduleVersion(studyId: $studyId, visitScheduleVersion: $visitScheduleVersion, reason: $reason) {
            ...StudyVisitScheduleFields
        }
    }
    ${StudyVisitScheduleFragment}
`;

export const SAVE_STUDY_VISIT_SCHEDULE_VISITS = gql`
    mutation saveStudyVisitScheduleVisits($studyId: ObjectId!, $visitScheduleId: ObjectId!, $visits: [StudySubjectVisitInput]!) {
        saveStudyVisitScheduleVisits(studyId: $studyId, visitScheduleId: $visitScheduleId, visits: $visits) {
            ...StudySubjectVisitFields
        }
    }
    ${StudySubjectVisitFragment}
`;

export const SAVE_STUDY_VISIT_SCHEDULE_VISIT = gql`
    mutation saveStudyVisitScheduleVisit($studyId: ObjectId!, $visitScheduleId: ObjectId!, $visit: StudySubjectVisitInput!, $reason: String) {
        saveStudyVisitScheduleVisit(studyId: $studyId, visitScheduleId: $visitScheduleId, visit: $visit, reason: $reason) {
            ...StudyVisitScheduleFields
        }
    }
    ${StudyVisitScheduleFragment}
`;

export const DELETE_STUDY_VISIT_SCHEDULE = gql`
    mutation deleteStudyVisitSchedule($studyId: ObjectId!, $visitScheduleId: ObjectId!, $reason: String) {
        deleteStudyVisitSchedule(studyId: $studyId, visitScheduleId: $visitScheduleId, reason: $reason)
    }
`;
export const DELETE_STUDY_VISIT_SCHEDULE_VISIT = gql`
    mutation  deleteStudyVisitScheduleVisit($studyId: ObjectId!, $visitScheduleId: ObjectId!, $visitId: ObjectId!, $reason: String) {
        deleteStudyVisitScheduleVisit(studyId: $studyId, visitScheduleId: $visitScheduleId, visitId: $visitId, reason: $reason)
    }
`;

export const GET_SUBJECT_VISIT_TEMPLATE_RULES_FIELDS: any = gql`
    query studyRulesFields($studyId: ObjectId!, $timestamp: DateTime) {
        studyRulesFields(studyId: $studyId, timestamp: $timestamp) {
            ...StudyVisitScheduleRuleFieldFields
        }
    }
    ${StudyVisitScheduleRuleFieldFragment}
`;

export const SAVE_STUDY_VISIT_SCHEDULE_VISITS_SEQUENCE = gql`
    mutation  saveStudyVisitScheduleVisitsSequence($visitScheduleId: ObjectId!, $studySubjectVisitSequence:[StudySubjectVisitSequenceInputType] !) {
        saveStudyVisitScheduleVisitsSequence(visitScheduleId: $visitScheduleId, studySubjectVisitSequence: $studySubjectVisitSequence)
    }
`;
